import { Stack, Typography } from '@mui/material';

export const BANNER_HEIGHT = 34;

function PlanCardBanner({
  text,
  color,
  border = true,
}: {
  text: string;
  color: string;
  border?: boolean;
}) {
  return (
    <Stack
      position="absolute"
      height={BANNER_HEIGHT}
      boxSizing="border-box"
      top={`-${BANNER_HEIGHT}px`}
      left={border ? '-1px' : 0}
      right={border ? '-1px' : 0}
      p={1}
      alignItems="center"
      justifyContent="center"
      bgcolor={color}
      sx={{
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
      }}>
      <Typography variant="h5" color="white">
        {text}
      </Typography>
    </Stack>
  );
}

export default PlanCardBanner;
